import '@components/common/layout/scrollbar.scss';

import { ReactComponent as EmptyPanelDroneIcon } from '@assets/components/panel/notification/empty-panel-drone-icon.svg';
import { Center, For, Separator, Spinner, Text, VStack } from '@chakra-ui/react';
import { ScrollArea } from '@components/ui/ScrollArea';
import { sortAlerts } from '@utils/data/notification.utils';
import { FormattedMessage } from 'react-intl';

import { AlertType, NotificationTypeEnum } from '@/types/data/data.types';

import Alert from './Alert';

type Props = {
  alerts: AlertType[];
  notificationType: NotificationTypeEnum;
  isLoading?: boolean;
  isArchived?: boolean;
};

export default function AlertList({
  alerts,
  notificationType,
  isLoading = false,
  isArchived = false,
}: Readonly<Props>) {
  if (isLoading) {
    return (
      <Center backgroundColor="neutral.900" paddingY={3} width="100%" zIndex={3}>
        <Spinner color="neutral.white" size="md" />
      </Center>
    );
  }

  const sortedAlerts = sortAlerts(alerts);

  return (
    <ScrollArea backgroundColor={isArchived ? 'neutral.900' : 'neutral.800'}>
      <VStack
        width="100%"
        height="100%"
        minHeight={isArchived ? 'max-content' : undefined}
        alignItems="start"
        zIndex={3}
        gap={0}
        userSelect="none"
      >
        <For
          each={sortedAlerts}
          fallback={
            <Center width="100%" height="100%" padding={3} backgroundColor="neutral.black">
              <VStack width="100%">
                {!isArchived && <EmptyPanelDroneIcon />}
                <Text textStyle="md" color="neutral.200">
                  <FormattedMessage id="components.notification.noAlert" />
                </Text>
              </VStack>
            </Center>
          }
        >
          {(alert, index) => (
            <>
              <Alert key={alert.id} alert={alert} notificationType={notificationType} isArchived={isArchived} />
              {index !== sortedAlerts.length - 1 && (
                <Separator borderColor={isArchived ? 'neutral.700' : 'neutral.900'} size="md" />
              )}
            </>
          )}
        </For>
      </VStack>
    </ScrollArea>
  );
}
